import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="relative bg-foreground-900 text-white overflow-hidden">
      <div className="absolute inset-0 pointer-events-none select-none flex items-center justify-center opacity-[0.04]">
        <span className="font-heading text-[12vw] font-bold whitespace-nowrap">OOPBUY SPREADSHEET</span>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="font-heading text-xl md:text-2xl font-bold text-white whitespace-nowrap cursor-pointer">
              OOPBuy Spreadsheet
            </Link>
            <p className="text-sm text-white/50 mt-4 leading-relaxed">
              Die deutsche Plattform für strukturierte Produktübersichten, Kategorien und Einkaufs-Guides. Finde die besten Produkte schneller.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Navigation</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer">
                  Startseite
                </Link>
              </li>
              <li>
                <Link to="/artikel/oopbuy-spreadsheet-guide" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer">
                  Kompletter Guide
                </Link>
              </li>
              <li>
                <Link to="/artikel/oopbuy-spreadsheet-schuhe" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer">
                  Schuhe Guide
                </Link>
              </li>
              <li>
                <Link to="/artikel/oopbuy-spreadsheet-sicherheit" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer">
                  Sicherheit
                </Link>
              </li>
              <li>
                <Link to="/artikel/oopbuy-spreadsheet-anfaenger" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer">
                  Anfänger Guide
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Kategorien</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">Mehr Kategorien</h4>
            <ul className="space-y-2.5">
              {categories.slice(7).map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 md:mt-14 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} OOPBuy Spreadsheet. Alle Rechte vorbehalten.
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-4 py-2 text-xs font-medium bg-white/10 text-white rounded-full hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer"
          >
            Zum Hauptportal →
          </a>
        </div>
      </div>
    </footer>
  );
}